<template>
  <div
    class="quick-view-sizes"
    :class="{ 'is-forward-animation': isForwardAnimation }"
    v-data-test-id="'quick-view-sizes'"
  >
    <div class="quick-view-sizes__title">{{ $t('filter.quickview.select_size') }}</div>
    <div class="quick-view-sizes__sizes-box">
      <Sizes
        class="quick-view-sizes__sizes"
        :variant="variant"
        :slug="slug"
        :variantSkus="variantSkus"
        :isVariantSock="isVariantSock"
        :sizeFinderButtonState="sizeFinderButtonState"
        :gender="variant.gender"
        :imageUrl="imageUrl"
        :isBackorderable="isBackorderable"
        :productName="productName"
        :isInsideQuickAdd="false"
        :isInsideQuickView="true"
        @select-size="handleSelectSize"
      />
      <div class="quick-view-sizes__fit">{{ variant.fit.sizeAndFit }}</div>
    </div>
    <span
      class="quick-view-sizes__back"
      @click="triggerStateChange"
      v-data-test-id="'sizes-back-button'"
    >
      <IconArrowBack />
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import updateCartMixin from '@/mixins/update-cart'
import { formatVariantSkusForOrder } from '@/components/ProductPage/transformation-helpers.js'
import IconArrowBack from '@/components/_icons/IconArrowBack.svg'
import Sizes from '@/components/_shared/Sizes/Sizes.vue'
import { STATES } from '@/components/_shared/Cards/Card/QuickView/QuickView.vue'

export default {
  name: 'QuickViewSizes',
  components: { IconArrowBack, Sizes },
  mixins: [updateCartMixin],
  props: {
    productName: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    variant: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isForwardAnimation: false,
    }
  },

  computed: {
    imageUrl() {
      return this.spreeProduct ? this.variant.defaultImage.mediaUrl : ''
    },

    isBackorderable() {
      return this.variant.spreeProduct.isBackorderable
    },

    sizeFinderButtonState() {
      return {
        isInactive: false,
        onClick: ($event, selectedSku) =>
          this.handleSizeFinderClick($event, selectedSku, this.updateCart),
        text: this.$t('size_guide.size_finder.add'),
      }
    },

    spreeProduct() {
      return this.variant.spreeProduct
    },

    isVariantSock() {
      return /sock/.test(this.spreeProduct.productUrl)
    },

    variantSkus() {
      return formatVariantSkusForOrder(this.variant.spreeProduct.spreeVariants || [])
    },
  },

  methods: {
    ...mapActions({
      hideSizeGuideOverlay: 'overlay/hideSizeGuideOverlay',
      hideQuickViewOverlay: 'overlay/hideQuickViewOverlay',
      showOutOfStockOverlay: 'overlay/showOutOfStockOverlay',
    }),

    triggerStateChange() {
      this.isForwardAnimation = false
      this.$nextTick(() => this.$emit('state-change', STATES.overview))
    },

    async handleSelectSize(selectedSkuObj, $event) {
      this.isForwardAnimation = true
      await this.$nextTick()
      const selectedSku = this.variantSkus.find(sku => sku.size === selectedSkuObj?.size)
      if ($event) this.updateCart({ selectedSku }, { context: this.$CONTEXTS.quickView })
      this.$emit('state-change', STATES.confirmation)
      this.$emit('select-size', selectedSkuObj)
    },

    handleSizeFinderClick($event, selectedSku, action) {
      this.hideSizeGuideOverlay()
      if (selectedSku.stock) {
        action(selectedSku)
        this.hideQuickViewOverlay()
      } else {
        this.showOutOfStockOverlay({
          sku: selectedSku.sku,
          slug: this.slug,
          imageUrl: this.imageUrl,
          isBackorderable: this.isBackorderable,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.quick-view-sizes {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20px;
  margin-top: 70px;
  display: flex;
  flex-direction: column;

  &__sizes-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }

  &__title {
    font-family: $font-family-helvetica-now;
    font-size: 18px;
    margin-bottom: 10px;
  }

  /deep/ .sizes__size {
    opacity: 1;
    height: 48px;
  }

  &__fit {
    font-size: $f-size-xsmall;
    color: $c-grey-dark-1;
    margin: 28px 0 10px;
  }

  &__back {
    margin: 0 auto;
  }
}
</style>
